<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="white--text primary"
        >SỬA TUYẾN XE
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-0 pb-6 pt-4">
        <BusInfoForm v-if="busData.id" :busData="busData" ref="form" class="mt-6 mx-6" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-6 py-4">
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BusInfoForm from '@/components/basic/form/bus/BusInfoForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BusInfoForm
  },
  props: {
    state: Boolean,
    busData: Object,
    slots: Array
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('busDetail', ['updateBus']),
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    },
    getChanges(currentData = {}) {
      const res = {}
      if (this.busData.name !== currentData.name) res['name'] = currentData.name
      if (this.busData.driver.id !== currentData.driver.id) res['driver'] = currentData.driver.id
      if (this.busData.status !== currentData.status) res['status'] = currentData.status
      if (this.busData.data.maxStudent !== currentData.data.maxStudent)
        res['data'] = { ...this.busData.data, maxStudent: currentData.data.maxStudent }
      return res
    },
    async save() {
      if (!this.$refs.form.validate()) return
      const data = this.getChanges(this.$refs.form.getData())
      this.$loading.active = true
      await this.updateBus({ id: this.busData.id, ...data })
      this.$loading.active = false
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
